import {
  getCommonParamsItemLabel,
  getGlobalParamsListItemLabel
} from '@/utils/common'

export const contentTableConfig = {
  // title: '('param.app-application-list')',
  title: '',
  propList: [
    {
      prop: 'online',
      label: 'Online Status',
      slotName: 'onlineStatus'
    },
    {
      prop: 'terminalId',
      label: 'terminal.id'
    },
    {
      prop: 'sn',
      label: 'terminal.sn',
      width: 160
    },
    {
      prop: 'tenantName',
      label: 'file.tenant',
      width: 180
    },
    {
      prop: 'merchantName',
      label: 'common.app-merchant-name',
      width: 180
    },
    {
      prop: 'modelId',
      label: 'file.model-type',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'terminalModel', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'status',
      label: 'common.app-status',
      width: 150,
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'terminal_status')
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 160
    },
    {
      label: 'common.app-operation',
      width: 480,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true,
  showSelectColumn: true
}
